import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {textFilter} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {
    CSVExport,
    ColumnToggle
} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import {Type} from 'react-bootstrap-table2-editor';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Moment from "moment";
import {getDistance} from 'geolib';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <button className="btn btn-success" onClick={handleClick}>
            Export Visible Data
        </button>
    );
};

const {ToggleList} = ColumnToggle;
const columns = [{
    dataField: 'index',
    text: 'Index',
    hidden: false,
    sort: true
}, {
    dataField: 'uniqueID',
    editable: () => {
        return false
    },
    hidden: true,
    text: 'GUID',
    filter: textFilter(),
}, {
    dataField: 'appVersion',
    editable: () => {
        return false
    },
    text: 'App Version',
    hidden: false,
    filter: textFilter(),
    sort: true,
}, {
    dataField: 'activateLocationCheck',
    text: 'Location Check',
    editable: () => {
        return false
    },
    sort: true,
    filter: textFilter(),
}, {
    dataField: 'active',
    text: 'Active',
    editor: {
        type: Type.SELECT,
        options: [{
            value: 'true',
            label: 'true'
        }, {
            value: 'false',
            label: 'false'
        }]
    },
    hidden: false,
    sort: true,
    filter: textFilter(),
}, {
    dataField: 'appType',
    text: 'App type',
    editable: () => {
        return false
    },
    hidden: false,
    sort: true,
    filter: textFilter()
}, {
    dataField: 'createdDate',
    text: 'Created',
    editable: () => {
        return false
    },
    formatter: dateFormatter,
    csvFormatter: dateFormatter,
    hidden: false,
    sort: true,
}, {
    dataField: 'lastUpdatedDate',
    text: 'Last Updated',
    editable: () => {
        return false
    },
    formatter: dateFormatter,
    csvFormatter: dateFormatter,
    hidden: false,
    sort: true,
}, {
    dataField: 'location',
    text: 'Location',
    hidden: true,
    sort: true,
    editable: () => {
        return false
    },
    filterValue: arrayFormatterForFilters,
    formatter: arrayFormatter,
    csvFormatter: arrayCsvFormatter
}, {
    dataField: 'locationStore',
    text: 'Store Name',
    editable: () => {
        return false
    },
    hidden: false,
    sort: true,
    filterValue: storeNameFormatter,
    sortValue: storeNameFormatter,
    formatter: storeNameFormatter,
    csvFormatter: storeNameFormatter,
    filter: textFilter(),
}, {
    dataField: 'locationLive',
    text: 'Location Live',
    hidden: true,
    sort: true,
    editable: () => {
        return false
    },
    filterValue: arrayFormatterForFilters,
    formatter: arrayFormatter,
    csvFormatter: arrayCsvFormatter,
}, {
    dataField: 'locationLiveName',
    text: 'Location Live Name',
    editable: () => {
        return false
    },
    hidden: false,
    sort: true,
    filterValue: storeNameFormatter,
    sortValue: storeNameFormatter,
    formatter: storeNameFormatter,
    csvFormatter: storeNameFormatter,
    filter: textFilter(),
}, {
    dataField: 'phoneInfo',
    text: 'Phone Info',
    editable: () => {
        return false
    },
    hidden: false,
    sort: true,
    filter: textFilter()
}];

function storeNameFormatter(cell, row) {
    let distance = 1000;
    let storeName = "ZZZ Unknown"
    if (typeof cell === 'undefined') {
        return storeName;
    }
    for (let i = 0; i < storeList.length; i++) {
        const newDistance = getDistance(
            {latitude: storeList[i].location.latitude, longitude: storeList[i].location.longitude},
            {latitude: cell.latitude, longitude: cell.longitude}
        );
        if (newDistance < distance) {
            distance = newDistance;
            storeName = storeList[i].name;
        }
    }
    return storeName;
}

function dateFormatter(cell, row) {
    return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY H:mm:ss');
}

function arrayCsvFormatter(cell, row) {
    if (typeof cell === 'undefined') {
        return "0, 0";
    }
    return cell.latitude + ", " + cell.longitude();
}

function arrayFormatterForFilters(cell, row) {
    if (typeof cell === 'undefined') {
        return "0, 0";
    }
    return cell.latitude + ", " + cell.longitude();
}

function arrayFormatter(cell, row) {
    let longLat = "0, 0";
    if (typeof cell !== 'undefined') {
        longLat = cell.latitude + "," + cell.longitude;
    }
    const googleMapLink = "http://www.google.com/maps/place/" + longLat;
    const googleMapIframeLink = "https://maps.google.com/maps?z=15&output=embed&q=" + longLat;
    return (
        <div>
            <a href={googleMapLink} target="_blank">{longLat}</a><br/>
            {/*<iframe src={googleMapIframeLink} width="360" height="270" frameBorder="0" style={{border: 0}}/>*/}
        </div>
    )
}

let storeList;

export const Devices = ({devices, handleDeviceActiveUpdate, stores}) => {
    storeList = stores;
    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    const options = {
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: devices.length
        }],
        showTotal: true
    }

    const handleActiveCellChange = (oldValue, newValue, row, column) => {
        if (oldValue !== newValue) {
            handleDeviceActiveUpdate(row.uniqueID, newValue)
        }
    };

    return (
        <ToolkitProvider
            keyField='index'
            data={devices}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div className="table-card">
                    {/* Table Actions */}
                    <div className="table-actions">
                        <div className="flex flex-wrap items-center gap-3">
                            <MyExportCSV {...props.csvProps}/>
                        </div>
                    </div>

                    {/* Column Toggle */}
                    <div className="column-toggle-section">
                        <p className="column-toggle-label">Show/Hide Columns:</p>
                        <ToggleList {...props.columnToggleProps} />
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <BootstrapTable striped bordered hover {...props.baseProps}
                                        cellEdit={cellEditFactory({
                                            mode: 'click',
                                            afterSaveCell: handleActiveCellChange,
                                        })}
                                        pagination={paginationFactory(options)}
                                        rowEvents={rowEvents}
                                        bootstrap4={true}
                                        tabIndexCell
                                        filter={filterFactory()}
                        />
                    </div>
                </div>
            )
            }
        </ToolkitProvider>
    )
}